(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (() => {
    const findCart = () => document.querySelector('.section.cart');
    const first = findCart();
    if (!first) return;

    document.documentElement.classList.add('js-cart'); // hides the "Uppfæra" fallback

    const sectionId = first.closest('.shopify-section')?.id.replace('shopify-section-', '');
    const shopRoot = window.Shopify?.routes?.root ?? '/';
    const reduce = matchMedia('(prefers-reduced-motion: reduce)');
    const timers = new Map();
    let queue = Promise.resolve();

    const setCount = (n) => {
      const link = document.querySelector('.header__cart');
      if (!link) return;
      let badge = link.querySelector('.header__cart-count');
      if (n > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'header__cart-count';
          link.append(badge);
        }
        badge.textContent = n;
        badge.setAttribute('aria-label', `${n} vörur í körfu`);
      } else {
        badge?.remove();
      }
    };

    // Swap in the server-rendered section; keep keyboard focus where it was
    const render = (html) => {
      const next = html && new DOMParser().parseFromString(html, 'text/html').querySelector('.section.cart');
      const current = findCart();
      if (!next || !current) return;

      const active = document.activeElement;
      const focusKey = active?.closest?.('.cart-item')?.dataset.key;
      const focusStep = active?.dataset?.step;

      const swap = () => {
        current.replaceWith(next);
        if (!focusKey) return;
        const item = next.querySelector(`.cart-item[data-key="${CSS.escape(focusKey)}"]`);
        const target = item?.querySelector(focusStep ? `[data-step="${focusStep}"]:not(:disabled)` : 'input') ?? item?.querySelector('input');
        target?.focus({ preventScroll: true });
      };

      if (document.startViewTransition && !reduce.matches) document.startViewTransition(swap);
      else swap();
    };

    const showError = (item, message) => {
      const box = item?.querySelector('.cart-item__error');
      const input = item?.querySelector('input[name="updates[]"]');
      if (input) input.value = item.dataset.qty; // back to what the server has
      if (box) {
        box.textContent = message || 'Ekki tókst að uppfæra körfuna. Reyndu aftur.';
        box.hidden = false;
      }
    };

    // One request at a time, in order, addressed by line key (not position)
    const change = (item, quantity, fallback) => {
      queue = queue.then(async () => {
        item.setAttribute('aria-busy', 'true');
        try {
          const res = await fetch(`${shopRoot}cart/change.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              id: item.dataset.key,
              quantity,
              sections: [sectionId],
              sections_url: location.pathname,
            }),
          });
          const data = await res.json();
          if (!res.ok) {
            item.removeAttribute('aria-busy');
            showError(item, data.description || data.message);
            return;
          }
          setCount(data.item_count);
          render(data.sections?.[sectionId]);
        } catch (_) {
          fallback(); // network trouble: do it the no-JS way
        }
      });
      return queue;
    };

    const qtyOf = (item) => Math.max(1, parseInt(item.querySelector('input[name="updates[]"]').value, 10) || 1);

    const schedule = (item) => {
      const key = item.dataset.key;
      clearTimeout(timers.get(key));
      item.querySelector('.cart-item__error').hidden = true;
      timers.set(key, setTimeout(() => {
        timers.delete(key);
        const q = qtyOf(item);
        if (String(q) === item.dataset.qty) return;
        change(item, q, () => item.closest('form')?.submit());
      }, 450));
    };

    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.cart .product__qty-btn');
      if (btn) {
        const item = btn.closest('.cart-item');
        const input = item.querySelector('input[name="updates[]"]');
        const n = Math.max(1, (parseInt(input.value, 10) || 1) + Number(btn.dataset.step));
        input.value = n;
        item.querySelector('[data-step="-1"]').disabled = n <= 1;
        schedule(item);
        return;
      }

      const remove = e.target.closest('.cart .cart-item__remove');
      if (remove) {
        e.preventDefault();
        const item = remove.closest('.cart-item');
        clearTimeout(timers.get(item.dataset.key));
        change(item, 0, () => { location.href = remove.href; });
      }
    });

    document.addEventListener('change', (e) => {
      if (!e.target.matches('.cart input[name="updates[]"]')) return;
      const item = e.target.closest('.cart-item');
      e.target.value = qtyOf(item);
      item.querySelector('[data-step="-1"]').disabled = qtyOf(item) <= 1;
      schedule(item);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    const form = document.getElementById('ProductForm');
    if (!form) return;

    const priceEl = document.querySelector('.product__price [data-price]');
    const compareEl = document.querySelector('.product__price [data-compare]');
    const add = document.getElementById('AddToCart');
    const qty = document.getElementById('Quantity');
    const minus = document.querySelector('.product__buy .product__qty-btn[data-step="-1"]');
    const labels = {
      add: add.querySelector('[data-text-add]'),
      soldout: add.querySelector('[data-text-soldout]'),
      busy: add.querySelector('[data-text-busy]'),
    };

    const show = (key) => {
      for (const [k, el] of Object.entries(labels)) el.hidden = k !== key;
    };

    const selected = () => {
      const radio = form.querySelector('input[name="id"]:checked');
      if (radio) return radio;
      const select = form.querySelector('select[name="id"]');
      if (select) return select.options[select.selectedIndex];
      return form.querySelector('input[type="hidden"][name="id"]');
    };

    const update = ({ pushUrl = false } = {}) => {
      const el = selected();
      if (!el) return;

      priceEl.textContent = el.dataset.price;
      compareEl.textContent = el.dataset.compare;
      compareEl.hidden = !el.dataset.compare;

      const ok = el.dataset.available === 'true';
      add.disabled = !ok;
      add.removeAttribute('aria-busy');
      show(ok ? 'add' : 'soldout');

      if (pushUrl && el.type !== 'hidden') {
        const url = new URL(location.href);
        url.searchParams.set('variant', el.value);
        history.replaceState(history.state, '', url);
      }
    };

    form.addEventListener('change', (e) => {
      if (e.target.name === 'id') update({ pushUrl: true });
    });

    // Quantity: never below 1, minus greys out at 1
    const clampQty = () => {
      const n = Math.max(1, parseInt(qty.value, 10) || 1);
      qty.value = n;
      if (minus) minus.disabled = n <= 1;
    };
    document.querySelectorAll('.product__buy .product__qty-btn').forEach((btn) => {
      btn.addEventListener('click', () => {
        qty.value = (parseInt(qty.value, 10) || 1) + Number(btn.dataset.step);
        clampQty();
      });
    });
    qty.addEventListener('change', clampQty);
    clampQty();

    // One press = one add. Double-clicks don't put two in the cart.
    form.addEventListener('submit', () => {
      add.setAttribute('aria-busy', 'true');
      show('busy');
      add.disabled = true;
    });

    // Back button restores the page from cache with the button still locked
    addEventListener('pageshow', (e) => {
      if (e.persisted) update();
    });

    // Thumbnails: crossfade the main photo; wait for decode so there's no blank frame
    const img = document.querySelector('#MainImage img');
    const thumbs = document.querySelectorAll('.product__thumb');
    const reduce = matchMedia('(prefers-reduced-motion: reduce)');

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!img || thumb.classList.contains('is-active')) return;

        const swap = async () => {
          img.srcset = thumb.dataset.srcset;
          img.src = thumb.dataset.src;
          img.alt = thumb.dataset.alt;
          try { await img.decode(); } catch (_) {}
        };

        thumbs.forEach((t) => {
          t.classList.toggle('is-active', t === thumb);
          t.toggleAttribute('aria-current', t === thumb);
        });

        if (document.startViewTransition && !reduce.matches) {
          document.startViewTransition(swap);
        } else {
          swap();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  (function () {
    var input = document.getElementById('SearchInput');
    var results = document.getElementById('SearchResults');
    if (!input || !results) return;

    var timer = null;
    var controller = null;
    var last = input.value.trim();

    function run(q) {
      if (controller) controller.abort();
      controller = new AbortController();
      results.classList.add('is-loading');

      var url = new URL(window.location.pathname, window.location.origin);
      if (q) { url.searchParams.set('q', q); url.searchParams.set('type', 'product'); }
      history.replaceState(null, '', url.search || window.location.pathname);
      url.searchParams.set('section_id', 'search');

      fetch(url.toString(), { signal: controller.signal })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.getElementById('SearchResults');
          if (fresh) results.innerHTML = fresh.innerHTML;
          results.classList.remove('is-loading');
        })
        .catch(function (e) {
          if (e.name !== 'AbortError') results.classList.remove('is-loading');
        });
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      if (q === last) return;
      last = q;
      clearTimeout(timer);
      timer = setTimeout(function () { run(q); }, 120);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
